/**
 * Service responsible for dealing with date formats
 */

import { Injectable } from '@angular/core';
import * as d3TimeFormat from "d3-time-format";

@Injectable()
export class DateFormatService {
 
    constructor() {
    };

    public apiTimeFormat(dateToFormat): string{
        var apiTimeFormatD3 = d3TimeFormat.timeFormat("%Y-%m-%dT%H:%M:%S")
        return apiTimeFormatD3(dateToFormat)
    } 
    public apiTimeFromFormat(dateToFormat): string{
        var apiTimeFromFormatD3 = d3TimeFormat.timeFormat("%Y-%m-%dT00:00:00")
        return apiTimeFromFormatD3(dateToFormat)
    } 
    public apiTimeToFormat(dateToFormat): string{
        var apiTimeToFormatD3 = d3TimeFormat.timeFormat("%Y-%m-%dT23:59:59")
        return apiTimeToFormatD3(dateToFormat)
    } 
    public getStartOftheWeek(dateToFormat): string{
        //step 1 find weekday 0 os sunday
        //if given date is sunday we need to roll over one week further back
        var slider;
        if(dateToFormat.getDay() == 0){
            slider = - 7 + 1;
        }
        else{
            slider = - dateToFormat.getDay() + 1;
        }
        var startOfWeek = new Date(dateToFormat.getFullYear(),dateToFormat.getMonth(), dateToFormat.getDate() + slider, 0, 0, 0);
        return this.apiTimeFromFormat(startOfWeek);
    }
    public getEndOftheWeek(dateToFormat): string{
        //step 1 find weekday 0 os sunday
        // +6 if we want week to end on staturday 23:59:59
        var slider;
        if(dateToFormat.getDay() == 0){
            slider = 0
        }
        else{
            slider = 7 - dateToFormat.getDay()// +1 because start of week should be Monday
        }
        var endOfWeek = new Date(dateToFormat.getFullYear(),dateToFormat.getMonth(), dateToFormat.getDate() + slider, 23, 59, 59);
        
        return this.apiTimeToFormat(endOfWeek);
    }
    public getStartOfMonth(dateToFormat): string{
        var startOfMonth = new Date(dateToFormat.getFullYear(), dateToFormat.getMonth(), 1, 0,0,0 );
        
        //if the first of the month is not a Monday we need to find the closest preceding Monday.
        if (startOfMonth.getDate() == 1){
            return this.getStartOftheWeek(startOfMonth)
        }
        else{
            var getStartOfMonth = d3TimeFormat.timeFormat("%Y-%m-01T00:00:00");
            return getStartOfMonth(startOfMonth);
        }
    } 
    public getEndOfMonth(dateToFormat): string{
        var lastMonthDay;
        var findMonth = d3TimeFormat.timeFormat("%m");
        var month = findMonth(dateToFormat);
        if (['01','03','05','07','08','10','12'].indexOf(month) > -1){
            lastMonthDay = 31;            
        }
        else if (['04','06','09','11'].indexOf(month) > -1){
            lastMonthDay = 30;            
            
        }
        else{
            var findYear = d3TimeFormat.timeFormat("%Y");
            var year = findYear(dateToFormat);
            if(year%4===0){
                lastMonthDay = 29;
            }
            else{
                lastMonthDay = 28;
            }
        }
        var lastMonthDate = new Date(dateToFormat.getFullYear(), dateToFormat.getMonth(), lastMonthDay, 0,0,0 );
        if (lastMonthDate.getDate() != 0){
            return this.getEndOftheWeek(lastMonthDate)
        }
        else{
            var getEndOfMonth = d3TimeFormat.timeFormat("%Y-%m-" + lastMonthDay + "T23:59:59");
            return getEndOfMonth(lastMonthDate)
        }
    };
    public getStartOfYear(dateToFormat): string{
        var getStartOfYear = d3TimeFormat.timeFormat("%Y-01-01T00:00:00")
        return getStartOfYear(dateToFormat)
    };
    public getEndOfYear(dateToFormat): string{
        var getEndOfYear = d3TimeFormat.timeFormat("%Y-12-31T23:59:59");
        return getEndOfYear(dateToFormat);
    } ;

}